<template>
  <SortSearch default-sort="latest" dimension="OurGraphics" />
</template>

<script>
import SortSearch from '@/components/SortSearch';

export default {
  components: {
    SortSearch
  },
  nuxtI18n: {
    paths: {
      en: '/our-graphics',
      es: '/nuestros-vectores',
      pt: '/nossos-vetores',
      de: '/our-graphics'
    }
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  }
};
</script>
